import { Instagram } from 'lucide-react'

interface ContactInfoItemProps {
  icon: React.ElementType;
  value?: string;
  isAddress?: boolean;
}

export const ContactInfoItem = ({ icon: Icon, value, isAddress = false }: ContactInfoItemProps) => {
  if (!value) return null;
  
  const textSizeClass = isAddress
    ? 'text-sm'
    : value.length > 25
      ? 'text-xs'
      : value.length > 20
        ? 'text-sm'
        : 'text-sm';
  
  const isInstagram = Icon === Instagram;
  
  if (isInstagram) {
    const instagramHandle = value.startsWith('@') ? value.substring(1) : value;
    const instagramUrl = `https://www.instagram.com/${instagramHandle}`;
    
    return (
      <div className="flex items-center space-x-2">
        <Icon className="h-4 w-4 flex-shrink-0" />
        <a 
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`${textSizeClass} ${isAddress ? '' : 'break-all'} hover:text-blue-800 hover:underline cursor-pointer`}
        >
          {value}
        </a>
      </div>
    );
  }
  
  return (
    <div className="flex items-center space-x-2">
      <Icon className="h-4 w-4 flex-shrink-0" />
      <span className={`${textSizeClass} ${isAddress ? '' : 'break-all'}`}>{value}</span>
    </div>
  );
};
